import React from 'react';
import { Modal, ModalBody } from 'reactstrap';
import EligiblityHistoryStatus from '../../../../Billing/Realtime/RealtimeDetails/Eligibility History/History/EligiblityHistoryStatus';

const AddNewEligibility = (props) => {
  const { EligibilityPopup, onClose, ID } = { ...props }
  return (
    <>
      {/* {EligibilityPopup === true ?
        <> */}
      <Modal show={EligibilityPopup} isOpen={EligibilityPopup} backdrop="static" keyboard={false} className='app-modal modal modal-dialog-centered modal-lg add_new_eligibility hk-modal-v1 table-default-design'>
        <ModalBody>
          <div className='d-flex justify-content-end' onClick={onClose}>
            <button className="btn-icon-transparent">
              <i className="icon-Icon-metro-cross"></i>
            </button>
          </div>
          <EligiblityHistoryStatus id={ID} type={'PlanInfo'} />
        </ModalBody>
      </Modal>
      {/* </> : null} */}
      {/* <Modal show={EligibilityPopup} backdrop="static" keyboard={false} centered dialogClassName="app-modal modal-lg hk-modal-v1">
       <Modal.Body>
       </Modal.Body>
     </Modal> */}
    </>
  );
};

export default AddNewEligibility;
